module.exports = __webpack_public_path__ + "static/media/speaker-events.94dc2e17.svg";